export const VIDEO_ACCESS_SCOPE = 'marketing-video';
export const CTAS_ACCESS_SCOPE = 'cta-access';
export const FORMS_ACCESS_SCOPE = 'forms-read';
export const VIDEO_SETTINGS = 'hsVideo';
export const hsvideoConfig = {
  DISABLE_SPACING: 'videoDisableSpacing',
  DISABLE_ALIGNMENT: 'videoDisableAlignment',
  MAX_DIMENSION_WIDTH: 'videoMaxDimensionWidth',
  USE_EMBED: 'videoUseEmbed',
  ENABLE_FULL_WIDTH: 'videoEnableFullWidth',
  USE_CONVERSION_ASSET_OPTIONS_PANEL: 'useConversionAssetOptionsPanel'
};
export const HublVideoTypes = {
  VIDYARD: 'scriptV4',
  HSVIDEO2: 'hsvideo2'
};